document.documentElement.classList.remove('no-js');

document.addEventListener('click', function (event) {
  const btn = event.target.closest('[data-accordion-button]');
  if (!btn) return;
  const item = btn.closest('.faq-item');
  item.classList.toggle('is-open');
  btn.setAttribute('aria-expanded', item.classList.contains('is-open') ? 'true' : 'false');
});

document.addEventListener('change', function (event) {
  const select = event.target.closest('[data-variant-select]');
  if (!select) return;
  const wrapper = select.closest('[data-product-root]');
  const price = wrapper && wrapper.querySelector('[data-product-price]');
  const option = select.options[select.selectedIndex];
  if (price && option.dataset.price) price.textContent = option.dataset.price;
});
